module.exports = __webpack_public_path__ + "img/m_10.355d78bd.png";